import { DatePicker as AntdDatePicker } from 'antd';
import styled, { createGlobalStyle } from 'styled-components';
import { Button } from '../Button';

export const StyledFooterRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 16px;
  border-top: 1px solid ${props => props.theme.colors.secondary.light.divider};
`;

export const StyledCancelButton = styled(Button)``;

export const StyledApplyButton = styled(Button)`
  margin-left: 16px;
`;

export const DatePickerDropdownStyles = createGlobalStyle`
  .my-range-picker-dropdown .ant-picker-presets{
    padding: 24px 16px;
    border-inline-end: 1px solid ${props => props.theme.colors.secondary.light.divider};
  }

  .ant-picker-presets ul {
    padding: 0 !important;
    border-inline-end: none !important;
  }

  .ant-picker-presets ul li +li {
    margin-top: 16px !important;
  }

  .ant-picker-presets ul li  {
   padding-inline: 0px !important;
  }

  .ant-picker-presets ul li:hover {
   background-color: transparent!important;
   color: ${props => props.theme.colors.primary.main.filled}!important;
  }

  .ant-picker-dropdown .ant-picker-header {
   margin: 16px 12px 0px 12px;
   border-radius: 8px;
   height: 35px;
   border: 1px solid ${props => props.theme.colors.secondary.light.divider};
  }

  .ant-picker-dropdown .ant-picker-header .ant-picker-header-view button {
   text-align: center;
   height: 100%;
  }
  .ant-picker-dropdown .ant-picker-content td {
   min-width: 40px;
  }

  .ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner::before {
   border: 1px solid ${props => props.theme.colors.primary.dark.filled} !important;
  }
   
  .ant-picker-dropdown .ant-picker-cell-in-view.ant-picker-cell-range-end:not(.ant-picker-cell-disabled) .ant-picker-cell-inner {
   background: ${props => props.theme.colors.primary.dark.filled} !important;
   color: ${props => props.theme.colors.primary.main.text} !important;
  }

  .ant-picker-dropdown .ant-picker-header-view >button {
   color: ${props => props.theme.colors.primary.main.filled};
  }

  .ant-picker-dropdown .ant-picker-cell::before {
   height?: 40px;
  }

  .ant-picker-dropdown .ant-picker-cell .ant-picker-cell-inner {
   min-width: 40px;
   height: 40px;
   line-height: 40px;
   display: flex;
   justify-content: center;
   align-items: center;
   border-radius: 8px;
   color: ${props => props.theme.colors.secondary.main.text};
  }

  .my-range-picker-dropdown 
  .ant-picker-cell-in-range::before {
  height: 40px !important;
  background-color: ${props => props.theme.colors.primary.light.linearHover} !important;
  }

 .my-range-picker-dropdown 
  .ant-picker-cell-in-range .ant-picker-cell-inner {
  height: 40px !important;
  min-width: 40px !important;
  line-height: 40px !important;
  }

 .my-range-picker-dropdown .ant-picker-cell-range-start::before,
 .my-range-picker-dropdown .ant-picker-cell-range-end::before {
  border-radius: 8px 0 0 8px !important;
  }
 .my-range-picker-dropdown 
  .ant-picker-cell-range-end::before {
  border-radius: 0 8px 8px 0 !important;
  }

  .ant-picker-date-panel .ant-picker-body {
   padding: 0px 24px;
  }
   
  .ant-picker-date-panel .ant-picker-body .ant-picker-content tbody tr td {
   padding: 2px 0px !important;
  }

  .dateRangePicker .ant-picker-panel:nth-child(2){
    display: none;
  }
    
  .dateRangePicker .ant-picker-panel:nth-child(1) button{
    visibility: visible !important;
  }
}
`;

export const StyledDatePicker = styled(AntdDatePicker.RangePicker)``;
